"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/Fabric/index'));

//# sourceMappingURL=Fabric.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./Fabric.js
 ** module id = 44
 ** module chunks = 0
 **/